// const baseURL = 'http://192.168.2.138:3005'
const baseURL = 'https://live.api.flhk.net'

module.exports = {
  baseURL,
}
